import {createStore, combineReducers, applyMiddleware} from 'redux'
import {composeWithDevTools} from 'redux-devtools-extension'
import thunk from 'redux-thunk'
import { userReducer, ordersReducer, locationReducer, notificationsReducer, searchReducer ,languageReducer } from './reducers'

export default createStore (
  combineReducers({userReducer, ordersReducer, locationReducer,notificationsReducer, searchReducer, languageReducer}), 
  composeWithDevTools(applyMiddleware(thunk))
)
